/* EKO hero video.
   1) prefers-reduced-motion: stop background video downloading/playing.
   2) Dual-video mode (separate desktop/mobile uploads): videos carrying
      data-hero-media render without autoplay and with preload="none"; only
      the element whose media query matches is played, so the hidden one
      never downloads. Re-evaluated when the viewport crosses the breakpoint.
   3) Perf: playback (and therefore the download — every hero video renders
      preload="none" without autoplay) starts only after window load AND the first
      LCP paint (+1 s, idle), so video bytes never compete with the LCP poster, CSS or JS.
      Save-Data and 2g/3g visitors keep the poster and download nothing; the
      play button still starts the video for them on request.
   4) Pause / play control (WCAG 2.2.2): any [data-eko-video-toggle] button in
      the same section pauses every hero video and flips to "play"; a user
      pause wins over the breakpoint auto-play. Hidden for reduced-motion
      visitors (nothing moves for them). */
(function () {
  function sectionOf(el) {
    return el.closest('.shopify-section') || el.parentElement;
  }

  function setToggleState(toggle, paused) {
    toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
    var label = paused ? toggle.getAttribute('data-play-label') : toggle.getAttribute('data-pause-label');
    if (label) toggle.setAttribute('aria-label', label);
  }

  function init() {
    var videos = document.querySelectorAll('video[data-eko-hero-video]');
    var toggles = document.querySelectorAll('[data-eko-video-toggle]');
    if (!videos.length || !window.matchMedia) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      for (var i = 0; i < videos.length; i++) {
        var v = videos[i];
        try { v.pause(); } catch (e) {}
        v.removeAttribute('autoplay');
        while (v.firstChild) v.removeChild(v.firstChild);
        try { v.load(); } catch (e) {}
      }
      for (var t = 0; t < toggles.length; t++) toggles[t].hidden = true;
      return;
    }

    var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    var lite = !!conn && (conn.saveData === true || /(^|-)[23]g$/.test(conn.effectiveType || ''));
    if (lite) {
      // Poster only; the toggle starts in its "play" state.
      for (var l = 0; l < videos.length; l++) {
        var s = sectionOf(videos[l]);
        if (s) s.setAttribute('data-eko-video-paused', '');
      }
    }

    for (var j = 0; j < videos.length; j++) {
      (function (video) {
        var media = video.getAttribute('data-hero-media');
        // single-video mode carries no media query: it plays at every width
        var mq = media ? window.matchMedia(media) : { matches: true };
        function apply() {
          var section = sectionOf(video);
          if (section && section.hasAttribute('data-eko-video-paused')) return;
          if (mq.matches) {
            var p = video.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            try { video.pause(); } catch (e) {}
          }
        }
        if (mq.addEventListener) {
          mq.addEventListener('change', apply);
        } else if (mq.addListener) {
          mq.addListener(apply);
        }
        apply();
      })(videos[j]);
    }

    for (var k = 0; k < toggles.length; k++) {
      (function (toggle) {
        var section = sectionOf(toggle);
        var own = section ? section.querySelectorAll('video[data-eko-hero-video]') : [];
        if (!own.length) { toggle.hidden = true; return; }
        setToggleState(toggle, lite);
        toggle.addEventListener('click', function () {
          var paused = toggle.getAttribute('aria-pressed') !== 'true';
          if (paused) {
            section.setAttribute('data-eko-video-paused', '');
            for (var i = 0; i < own.length; i++) { try { own[i].pause(); } catch (e) {} }
          } else {
            section.removeAttribute('data-eko-video-paused');
            for (var j = 0; j < own.length; j++) {
              var media = own[j].getAttribute('data-hero-media');
              if (media && !window.matchMedia(media).matches) continue;
              var p = own[j].play();
              if (p && p.catch) p.catch(function () {});
            }
          }
          setToggleState(toggle, paused);
        });
      })(toggles[k]);
    }
  }

  /* Start only once the LCP (the hero poster) has really painted. On slow
     devices first paint lands AFTER window load, so "load" alone lets the video
     request race the poster and Lighthouse bills the whole MP4 to LCP. */
  var started = false;
  function start() {
    if (started) return;
    started = true;
    setTimeout(function () {
      if (window.requestIdleCallback) {
        window.requestIdleCallback(init, { timeout: 2000 });
      } else {
        init();
      }
    }, 1000);
  }

  function afterLcp() {
    var supported = window.PerformanceObserver && PerformanceObserver.supportedEntryTypes &&
      PerformanceObserver.supportedEntryTypes.indexOf('largest-contentful-paint') !== -1;
    if (!supported) { start(); return; } // Safari/Firefox: load + delay
    try {
      var po = new PerformanceObserver(function (list) {
        if (list.getEntries().length) { po.disconnect(); start(); }
      });
      po.observe({ type: 'largest-contentful-paint', buffered: true });
    } catch (e) { start(); }
    setTimeout(start, 8000); // hidden tab etc.: never strand the video
  }

  if (document.readyState === 'complete') {
    afterLcp();
  } else {
    window.addEventListener('load', afterLcp);
  }
})();
